export interface Camera {
  x: number;
  y: number;
  zoom: number;
  devicePixelRatio: number;
}

export function createDefaultCamera(): Camera {
  return {
    x: 0,
    y: 0,
    zoom: 1,
    devicePixelRatio: typeof window === "undefined" ? 1 : window.devicePixelRatio || 1,
  };
}
